import "./common.css";

export default function ConfirmationModal({ 
    children, 
    title = "Confirmer l'action",
    icon = "⚠️",
    iconType = "warning", // "warning" | "danger" | "info" | "success"
    confirmText = "Confirmer",
    cancelText = "Annuler",
    confirmVariant = "danger", // "danger" | "primary"
    onConfirm, 
    onCancel,
    showCloseButton = true
}) {
    const handleOverlayClick = (e) => {
        if (e.target === e.currentTarget) {
            onCancel?.();
        }
    };

    return (
        <div className="modal-overlay" onClick={handleOverlayClick}>
            <div className="modal-card">
                {showCloseButton && (
                    <button className="modal-close" onClick={onCancel} aria-label="Fermer">
                        ✕
                    </button>
                )}
                
                <div className={`modal-icon ${iconType}`}>
                    {icon}
                </div>
                
                <div className="modal-content">
                    <h2 className="modal-title">{title}</h2>
                    <p className="modal-message">{children}</p>
                </div>
                
                <div className="modal-actions">
                    <button 
                        className="modal-btn modal-btn-cancel" 
                        onClick={onCancel}
                    >
                        {cancelText}
                    </button>
                    <button 
                        className={`modal-btn modal-btn-confirm ${confirmVariant}`} 
                        onClick={onConfirm}
                    >
                        {confirmText}
                    </button>
                </div>
            </div>
        </div>
    );
}
